import { useState, useMemo, FunctionComponent, useEffect, useRef } from "react";
import alerticonError from "../../assets/dropdown/alert-icon-error.svg";
import otlchevronforward1 from "../../assets/dropdown/otlchevronforward1@2x.png";

interface SearchableInputsDropdownProps {
    label: string;
    placeHolder?: string;
    propMinWidth?: string;
    options: any;
    onSelect?: any;
    errorMessage?: any;
    payerName?: any;
    payerId?: any;
    initialValue?: any;
    disableDropdown?: boolean;
    showSearchable?: boolean;
    onChange?: any;
    clearSelected?: any
    singleSelect?: any
    pageType?: any
    dontselectlastValue?: any
}

const SearchableInputsDropdown: FunctionComponent<
    SearchableInputsDropdownProps
> = ({
    label,
    placeHolder,
    propMinWidth,
    options,
    onSelect,
    errorMessage,
    payerName,
    payerId,
    initialValue,
    disableDropdown,
    showSearchable,
    onChange,
    clearSelected,
    singleSelect,
    pageType,
    dontselectlastValue
}) => {
        const [isOpen, setIsOpen] = useState(false);
        const [selectedOption, setSelectedOption] = useState(
            initialValue || placeHolder
        );
        const dropdownRef = useRef<HTMLDivElement>(null);
        const [inputValue, setInputValue] = useState<any>(""); //added for new feature
        const [lastSelectedOption, setLastSelectedOption] = useState(
            initialValue || ""
        ); //added for new feature

useEffect(() => {
  if (clearSelected) {
    setSelectedOption(placeHolder);
    setInputValue("");
    setLastSelectedOption(placeHolder);
  }
}, [clearSelected, placeHolder]);

        // Effect to handle initial value setting
        useEffect(() => {
            if (
                initialValue !== undefined &&
                initialValue !== "" &&
                initialValue !== null
            ) {
                setSelectedOption(initialValue);
                setLastSelectedOption(initialValue);
                setInputValue(initialValue);
            }
        }, [initialValue]);

        useEffect(() => {
            if (payerId && payerName) {
                handleOptionSelect(payerId, payerName);
            }
        }, [payerId, payerName]);

        // If one item then select
        useEffect(() => {
            if (options?.length === 1 && singleSelect && pageType === "shift") {
                handleOptionSelect(options[0]?.key, options[0]?.name, options[0]?.type);
            }
        }, [options[0]?.key, singleSelect, pageType]);

        useEffect(() => {
            function handleClickOutside(event: MouseEvent) {
                if (
                    dropdownRef.current &&
                    !dropdownRef.current.contains(event.target as Node)
                ) {
                    if (!dontselectlastValue) {
                        //added for new feature
                        if (
                            !options.some(
                                (option: any) =>
                                    option?.name?.toLowerCase() === inputValue?.toLowerCase()
                            )
                        ) {
                            setInputValue(lastSelectedOption);
                        }
                    }

                    setIsOpen(false);
                }
            }

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [dropdownRef]);

        const content1Style = useMemo(() => {
            return {
                minWidth: propMinWidth,
            };
        }, [propMinWidth]);

        function handleDropdownToggle() {
            if (!disableDropdown) {
                setIsOpen(!isOpen);
                //added for new feature
                if (!isOpen) {
                    setInputValue("");
                }
            }
        }

        function handleOptionSelect(
            key: any,
            name: any,
            type?: any,
            index?: any,
            matchedArray?: any
        ) {
            setSelectedOption(name);
            setLastSelectedOption(name); //added for new feature
            setIsOpen(false);
            setInputValue(name); //added for new feature
            if (onSelect) {
                onSelect(key, name, type, index, matchedArray);
            }
        }

        //added for new feature
        const filteredOptions = options?.filter((option: any) =>
            option?.name?.toLowerCase()?.includes(inputValue?.toLowerCase())
        );

        // Determine border class based on errorMessage
        const borderClass = errorMessage
            ? "border-2 border-rose-500 dark:border-rose-500 darkinputborder"
            : "border-surface-border";

        return (
            <div
                id="addinterration-blg-dv"
                className={`relative flex-1 inputnew-div cts-flex1-remd flex flex-col items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg min-w-full `}
                ref={dropdownRef}
            >
                <label className="self-stretch relative font-semibold pb-2 dark:text-white">
                    {label}
                </label>
                <div className="self-stretch flex flex-col items-start justify-start text-text-text-secondary dark:text-white">
                    <div
                        id="cts-dropdown-dv"
                        className={`self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] dark:bg-slate-700 rounded-radius-md bg-text-text-tertiary overflow-hidden h-[20px] flex flex-row items-center justify-start py-2.5 px-[15px] gap-[8px] border-[1px] border-solid ${borderClass} mq450:flex-wrap
          ${disableDropdown ? "caretask_dropdowndisbale" : ""}`}
                        onClick={handleDropdownToggle}
                    >
                        {showSearchable && showSearchable === true ? (
                            <div
                                className="flex-1 flex flex-row items-center justify-start"
                                style={content1Style}
                            >
                                <div className="flex-1 relative">{selectedOption}</div>
                            </div>
                        ) : (
                            <input
                                type="text"
                                className="flex-1 bg-transparent border-none outline-none text-gray-500 dark:text-white"
                                placeholder={selectedOption}
                                value={inputValue}
                                onChange={(e) => {
                                    setInputValue(e.target.value);
                                    setIsOpen(true);
                                }}
                                onClick={() => setIsOpen(true)}
                                disabled={disableDropdown}
                            />
                        )}

                        {/* added for new feature */}

                        <img
                            className={`h-4 w-4 relative overflow-hidden shrink-0 object-contain transform dark-white-img transition-transform ${isOpen ? "rotate-180" : ""
                                }`}
                            alt=""
                            src={otlchevronforward1}
                        />
                    </div>
                    {isOpen && (
                        <div className="cts-zindex-dv absolute left-0 mt-11 w-full self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-white border-[1px] border-solid border-surface-border z-50">
                            {/* added for new feature */}
                            {filteredOptions?.length > 0 ? (
                                filteredOptions?.map((option: any, index: any) => (
                                    <div
                                        key={index}
                                        className="py-2 px-[15px] hover:bg-gray-100 dark:hover:dark:bg-slate-500 cursor-pointer"
                                        onClick={() =>
                                            handleOptionSelect(
                                                option.key,
                                                option.name,
                                                option.type,
                                                option.index,
                                                option.matchedArray
                                            )
                                        }
                                    >
                                        {option.name}
                                    </div>
                                ))
                            ) : (
                                <div className="py-2 px-[15px] text-center text-gray-500">
                                    No options found
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {errorMessage && (
                    <p className="text-red p-2 my-0 cts-bg-error flex items-center gap-[4px] ctcerror-width-blg mt-2">
                        <img src={alerticonError} alt="" /> {errorMessage.message}
                    </p>
                )}
            </div>
        );
    };

export default SearchableInputsDropdown;
